import {
  Button,
  Col,
  Row,
  Space,
  Typography,
  Select,
  Input,
  Radio,
  Form,
  message,
} from "antd";
import React, {useEffect, useState} from "react";
import {FIELD_TYPE} from "types/enums";
import {FORMAT_TIME} from "types/enums/format-time";
import Icons from "assets/icons";
import {DataInputField, InputFields} from "components/common";
import Icon from "@ant-design/icons";
import "./FundusExpand.scss";
import {
  FieldsFundus1,
  FieldsFundus2,
  listCup,
  listFundus,
  listMedia,
  listOptic,
  listPVD,
  listRetinal,
  listVitreous,
} from "./FundusExpand.config";
import FormItem from "components/common/InputFields/FormItem/FormItem";
import {useAppSelector} from "redux/hooks";

const {INPUT, COMBO_BOX, TEXT_AREA, TIME, TRA_THUOC} = FIELD_TYPE;

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};
const wrapperCol = {xs: 24, md: 24, lg: 24};
const labelCol = {xs: 0, md: 0, lg: 0};
const FundusExpand: React.FC<Props> = ({isOpen, setIsOpen, index}) => {
  const name = index == 1 ? "leftJsonValue" : "rightJsonValue";
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue(
          [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "FUNDUS"],
          null
        );
      }
    }
    if (ref) {
      ref.setFieldValue(
        [
          `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
          "FUNDUS",
          "show",
        ],
        isOpen
      );
    }
  }, [isOpen, ref]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "FUNDUS",
        "show",
      ]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, ref]);
  return (
    <Space
      direction="vertical"
      className="space-common space-fundus"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub /> : <Icons.add />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">ĐÁY MẮT</Typography>
      </Row>

      {isOpen ? (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <DataInputField
                itemScale={{first: 6, second: 18}}
                label="Quan sát"
                children={
                  <Row gutter={0}>
                    <Col span={12}>
                      <FormItem
                        type={COMBO_BOX}
                        options={listMedia}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Quan sát", "text1"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        type={INPUT}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Quan sát", "text2"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                  </Row>
                }
              />
            </Col>

            <Col span={24}>
              <DataInputField
                label="Bong dịch kính sau"
                itemScale={{first: 6, second: 18}}
                children={
                  <FormItem
                    type={COMBO_BOX}
                    options={listPVD}
                    labelCol={labelCol}
                    wrapperCol={wrapperCol}
                    name={[name, "FUNDUS", "PVD"]}
                    // className="data-input-fundus"
                  ></FormItem>
                }
              />
            </Col>

            <Col span={24}>
              <DataInputField
                label="Kích thước đĩa thị"
                itemScale={{first: 6, second: 18}}
                children={
                  <FormItem
                    type={COMBO_BOX}
                    options={listOptic}
                    labelCol={labelCol}
                    wrapperCol={wrapperCol}
                    name={[name, "FUNDUS", "Kích thước đĩa thị"]}
                    // className="data-input-fundus"
                  ></FormItem>
                }
              />
            </Col>

            <Col span={24}>
              <DataInputField
                itemScale={{first: 6, second: 18}}
                label="Tỷ lệ C/D"
                children={
                  <Row gutter={0}>
                    <Col span={12}>
                      <FormItem
                        type={COMBO_BOX}
                        options={listCup}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Tỷ lệ C/D", "text1"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        type={INPUT}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Tỷ lệ C/D", "text2"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                  </Row>
                }
              />
            </Col>

            {/* <Col span={24}>
              <DataInputField
                label="Optic Disc"
                itemScale={{first: 6, second: 18}}
                children={
                  <Input
                    className="data-input-fundus"
                    suffix={
                      <Icon
                        rev={0}
                        style={{fontSize: "24px"}}
                        component={
                          Icons.file as React.ForwardRefExoticComponent<any>
                        }
                      />
                    }
                  />
                }
              />
            </Col> */}

            <Col span={24}>
              <DataInputField
                itemScale={{first: 6, second: 18}}
                label="Mạch máu"
                children={
                  <Row gutter={0}>
                    <Col span={12}>
                      <FormItem
                        type={COMBO_BOX}
                        options={listFundus}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Mạch máu", "text1"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        type={INPUT}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Mạch máu", "text2"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                  </Row>
                }
              />
            </Col>

            <Col span={24}>
              <Row align={"top"} justify={"center"}>
                <InputFields
                  data={index === 0 ? FieldsFundus1 : FieldsFundus2}
                />
              </Row>
            </Col>

            <Col span={24}>
              <DataInputField
                itemScale={{first: 6, second: 18}}
                label="Dịch kính"
                children={
                  <Row gutter={0}>
                    <Col span={12}>
                      <FormItem
                        type={COMBO_BOX}
                        options={listVitreous}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Dịch kính", "text1"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        type={INPUT}
                        options={listVitreous}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Dịch kính", "text2"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                  </Row>
                }
              />
            </Col>
            <Col span={24}>
              <DataInputField
                itemScale={{first: 6, second: 18}}
                label="Bong võng mạc"
                children={
                  <Row gutter={0}>
                    <Col span={12}>
                      <FormItem
                        type={COMBO_BOX}
                        options={listRetinal}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Bong võng mạc", "text1"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        type={INPUT}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Bong võng mạc", "text2"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                  </Row>
                }
              />
            </Col>
            <Col span={24}>
              <DataInputField
                itemScale={{first: 6, second: 18}}
                label="Tổn thương đáy mắt"
                children={
                  <Row gutter={0}>
                    <Col span={12}>
                      <FormItem
                        type={COMBO_BOX}
                        options={listFundus}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Tổn thương đáy mắt", "text1"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        type={INPUT}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        name={[name, "FUNDUS", "Tổn thương đáy mắt", "text2"]}
                        // className="data-input-fundus"
                      ></FormItem>
                    </Col>
                  </Row>
                }
              />
            </Col>

            <Col span={24}>
              <DataInputField
                label="Đáy mắt"
                itemScale={{first: 6, second: 18}}
                children={
                  <FormItem
                    type={INPUT}
                    labelCol={labelCol}
                    wrapperCol={wrapperCol}
                    name={[name, "FUNDUS", "Đáy mắt"]}
                    // className="data-input-fundus"
                  ></FormItem>
                }
              />
            </Col>

            <Col span={24}>
              <DataInputField
                label="Ghi chú"
                itemScale={{first: 6, second: 18}}
                children={
                  <FormItem
                    type={INPUT}
                    labelCol={labelCol}
                    wrapperCol={wrapperCol}
                    name={[name, "FUNDUS", "Ghi chú"]}
                    // className="data-input-fundus"
                  ></FormItem>
                }
              />
            </Col>
            {/* <Col span={24}>
              <Button
                onClick={() => {
                  message.info("Chức năng đang hoàn thiện");
                }}
                style={{background: "#003828", color: "#FFFFFF"}}
              >
                Add Cornea Diagram
              </Button>
            </Col> */}
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default FundusExpand;
